import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MyserviceService} from './myservice.service';

@Injectable({
  providedIn: 'root'
})
export class ActivateGuard implements CanActivate {

  constructor(private serv:MyserviceService, private router:Router){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if(JSON.parse(localStorage.getItem('log'))==true){
      console.log("==================")
      return true;
    }
    else{
      alert("You are not allowed to access this page without login ");
      this.router.navigate(['home']);
    }
  }

}
